import styled, { css } from "styled-components";

// The card for one form / signup-email variant in the campaign editor. Both
// states sit on the card surface, so a paused card never melts into the gray
// section behind it. Active: solid border, green stripe, soft shadow. Paused:
// faint diagonal hatching, dashed border, gray stripe, no shadow, muted title
// (plus the "Paused" pill). All theme tokens, so it works in light and dark.
const VariantCard = styled.div`
  padding: 14px 16px;
  border-radius: 8px;
  background: var(--color-bg-2);
  border: 1px solid var(--color-border-2);
  border-left: 3px solid rgb(var(--green-6));
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  ${(p) => !p.$active && css`
    background:
      repeating-linear-gradient(135deg, transparent 0 9px, var(--color-fill-2) 9px 11px),
      var(--color-bg-2);
    border: 1px dashed var(--color-border-3);
    border-left: 3px solid var(--color-border-3);
    box-shadow: none;

    h6.arco-typography {
      color: var(--color-text-3);
    }
  `}
`;

export default VariantCard;
